import React from 'react'
import {Alert} from 'antd'

export class ForgotPassword extends React.Component {
   render() {
      return (
         <Alert
            type="error"
            title="Not Implemeneted"
            description="This feature is not yet part of our production offering"
         />
      )
   }
}



// WEBPACK FOOTER //
// lib/bundle/auth/ForgotPassword.jsx